// import Swiper JS
import Swiper, { Navigation } from 'swiper';
Swiper.use([Navigation]);
// import Swiper styles
import 'swiper/css';

const imageBoxSwiper = new Swiper('.image-box-swiper', {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: false,
    centeredSlides: true,
  
    // Navigation arrows
    navigation: {
      nextEl: ".image-box-swiper-button-prev",
      prevEl: ".image-box-swiper-button-next",
    },

  });